import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const FormatItalicNewIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            fill='currentColor'
            // eslint-disable-next-line max-len
            d='M14.9779 4.0005H10.5C9.94772 4.0005 9.5 4.44822 9.5 5.0005C9.5 5.55279 9.94772 6.0005 10.5 6.0005H13.4835L8.3406 18.0005H5.5C4.94772 18.0005 4.5 18.4482 4.5 19.0005C4.5 19.5528 4.94772 20.0005 5.5 20.0005H8.97696C8.99203 20.0008 9.00708 20.0008 9.0221 20.0005H13.5C14.0523 20.0005 14.5 19.5528 14.5 19.0005C14.5 18.4482 14.0523 18.0005 13.5 18.0005H10.5165L15.6594 6.0005H18.5C19.0523 6.0005 19.5 5.55279 19.5 5.0005C19.5 4.44822 19.0523 4.0005 18.5 4.0005H15.023C15.008 4.00016 14.9929 4.00016 14.9779 4.0005Z'
        />
    </svg>
));
